import { queries } from "../../shared/queries";
import { routes, useRouteMatch } from "../lib/urls";
import { useHasAccess } from "./useHasAccess";
import { isSpaceMember, useSpaces } from "./useSpaces";
import { useQuery } from "./useQuery";

// Viewing a member space is normally just… viewing it, so the admin view only
// follows into one when the navigation came from the admin nav. That intent
// can't live in the URL (the member-space URL is identical either way), so the
// admin nav marks it here and Backdrop clears it when the admin view exits.
let adminViewSpaceId: string | null = null;

export function markAdminViewSpace(spaceId: string) {
  adminViewSpaceId = spaceId;
}

export function clearAdminViewSpace() {
  adminViewSpaceId = null;
}

export function useAdminSpaceView() {
  const canReadSpaces = useHasAccess("tenant:spaces_read");
  const [readableSpaces] = useSpaces({ settingsView: false });
  const memberSpaceIds = new Set(
    readableSpaces.filter(isSpaceMember).map((s) => s.id)
  );
  const [, spaceMatch] = useRouteMatch(routes.space);
  const { spaceId } = spaceMatch as { spaceId?: string };
  const [activeSpace] = useQuery(
    spaceId ? queries.navSpace({ spaceId }) : null
  );

  if (
    !spaceId ||
    !canReadSpaces ||
    !activeSpace ||
    activeSpace.mode === "personal" ||
    (memberSpaceIds.has(spaceId) && adminViewSpaceId !== spaceId)
  ) {
    return null;
  }

  return activeSpace;
}
